/**
 * Returns the corresponding UV Description when provided with UV Index value
 * also returns a translation key
 *
 * @param {number} uvIndex - The uv index to retrieve its matching description
 * @return {object} returns an object with uv index description with corresponding tranlation key.
 */

const uvDescriptions = {
    notAvailable: 'Not Available',
    low: 'Low',
    moderate: 'Moderate',
    high: 'High',
    veryHigh: 'Very High',
    extreme: 'Extreme'
};

export function getUvDescriptionFromUVIndexUtil(uvIndex) {

    let uvDescription = uvDescriptions.notAvailable;

    if (uvIndex >= 0 && uvIndex <= 2)
    {
        uvDescription = uvDescriptions.low;
    }
    else if (uvIndex >= 3 && uvIndex <= 5)
    {
        uvDescription = uvDescriptions.moderate;
    }
    else if (uvIndex >= 6 && uvIndex <= 7)
    {
        uvDescription = uvDescriptions.high;
    }
    else if (uvIndex >= 8 && uvIndex <= 10)
    {
        uvDescription = uvDescriptions.veryHigh;
    }
    else if(uvIndex >= 11 && uvIndex <= 9999)
    {
        uvDescription = uvDescriptions.extreme;
    }

    const uvIndexTranslateKey = Object.keys(uvDescriptions).find(key => uvDescriptions[key] === uvDescription);

    const uvIndexDescription = {
        uvDescription,
        uvIndexTranslateKey
    };

    return uvIndexDescription;
}
